import initialState from './initial-state';
import actionTypes from '../actions/action-types';

const appReducer = (state = initialState.app, action) => {
  switch (action.type) {
    case actionTypes.app.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default appReducer;
